// removed by extract-text-webpack-plugin
module.exports = {"termsContainer":"termsContainer__qNUv3"};


//////////////////
// WEBPACK FOOTER
// ./components/common/instacredTnC/style.css
// module id = 0v8L
// module chunks = 458